import { createFileRoute } from "@tanstack/react-router";
import { SignedConfirmScreen } from "../../screens/confirm/SignedConfirmScreen.tsx";

/** `/confirm#r=…`: the signed link an API key or an AI agent hands over (`SignedConfirmScreen`). */
export const Route = createFileRoute("/_app/confirm/")({
  component: SignedConfirmScreen,
});
